import { render } from "./App.vue?vue&type=template&id=5fbfd754"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5fbfd754&lang=css"

import exportComponent from "/home/shicksal/Documentos/Trabajos/Vue-js/vue-udemy/04-pokemon-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__